<div
  data-testid="order-create-layout-container"
  class="order-create-layout-container"
>
  <!-- Header with action buttons -->
  <div class="sticky-header flex justify-between items-center px-4 py-3">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ titleKey | translate }}
    </h2>
    <div class="flex gap-3">
      <app-button
        *ngFor="let action of headerActions"
        [testId]="'order-create-layout-header-action-' + action.action"
        [label]="action.label"
        [icon]="action.icon"
        (emitOnClick)="onHeaderAction(action.action)"
        [outlined]="action.outlined || false"
        [type]="action.severity || 'primary'"
        [disabled]="isHeaderActionDisabled(action)"
        [loading]="isHeaderActionLoading(action)"
      ></app-button>
    </div>
  </div>
  <div class="left-rail">
    <!-- 1. Order Information -->
    <section class="form-section">
      <h2 class="section-title text-sm">
        {{ "o2o.create.form.sections.order_basic_information" | translate }}
      </h2>
      <div class="grid gap-2 px-4 py-2 grid-cols-3">
        <ng-container
          *ngFor="
            let field of fieldsBySection(
              'o2o.create.form.sections.order_basic_information'
            );
            trackBy: trackByControlName
          "
        >
          <div
            class="form-field"
            *ngIf="visibleInContext(field)"
            [class.col-span-2]="field.colspan === 2"
            [class.col-span-4]="field.colspan === 4"
          >
            <label [for]="field.controlName" class="form-label text-sm">
              {{ field.label | translate }}
              <span *ngIf="field.required" class="text-red-500">*</span>
            </label>
            <ng-container [ngSwitch]="field.type">
              <textarea
                *ngSwitchCase="'textarea'"
                [id]="field.controlName"
                class="w-full text-sm"
                [placeholder]="field.placeholder | translate"
                rows="3"
                [attr.required]="field.required ? '' : null"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="form.get(field.controlName)?.setValue($event)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
                [readonly]="field.readonly || false"
              ></textarea>
              <p-select
                *ngSwitchCase="'dropdown'"
                [options]="getOptions(field.controlName)"
                optionLabel="label"
                optionValue="value"
                [placeholder]="field.placeholder | translate"
                [attr.required]="field.required ? '' : null"
                [emptyMessage]="
                  field.emptyMessage || ('common.no_results' | translate)
                "
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="
                  field.controlName === 'takingDeliveryWay'
                    ? onTakingDeliveryWayChange($event)
                    : field.controlName === 'shippingUnit' ||
                        field.controlName === 'shippingService'
                      ? onFieldChange($event, field)
                      : form.get(field.controlName)?.setValue($event)
                "
                [ngModelOptions]="{ standalone: true }"
                class="w-full text-sm"
                [disabled]="field.disabled || field.readonly || false"
              >
              </p-select>
              <app-advanced-datepicker
                *ngSwitchCase="'date'"
                [attr.data-testid]="'order-create-layout-date-' + field.controlName"
                mode="single"
                [showTime]="field.showTime || false"
                [timeFormat]="field.hourFormat === '12' ? '12h' : '24h'"
                [placeholder]="field.placeholder | translate"
                [required]="field.required || false"
                [minDate]="getMinDate(field)"
                [maxDate]="field.maxDate"
                [dateFormat]="'DD/MM/YYYY'"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="onDateSelect(field.controlName, $event)"
                [ngModelOptions]="{ standalone: true }"
                class="w-full text-sm"
                [disabled]="field.disabled || field.readonly || false"
              ></app-advanced-datepicker>
              <input
                *ngSwitchCase="'currency'"
                pInputText
                class="w-full text-sm"
                [value]="formatCurrency(getPaymentValue(field.controlName))"
                [attr.value]="formatCurrency(getPaymentValue(field.controlName))"
                [placeholder]="field.placeholder | translate"
                type="text"
                [attr.required]="field.required ? '' : null"
                [disabled]="true"
                readonly
              />
              <input
                *ngSwitchDefault
                pInputText
                class="w-full text-sm"
                [class.ng-invalid]="getFieldError(field.controlName)"
                [placeholder]="field.placeholder | translate"
                type="text"
                [attr.required]="field.required ? '' : null"
                [attr.value]="getPaymentValue(field.controlName) ?? null"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="form.get(field.controlName)?.setValue($event)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
                [readonly]="field.readonly || false"
              />
            </ng-container>
            <small
              *ngIf="getFieldError(field.controlName)"
              class="text-red-500 text-xs mt-1 block"
            >
              {{ getFieldError(field.controlName) | translate: getFieldErrorParams(field.controlName) }}
            </small>
          </div>
        </ng-container>
      </div>
    </section>

    <!-- 2. Order Items -->
    <section class="form-section">
      <h2 class="section-title text-sm">
        {{
          tableSections && tableSections[0].title
            ? (tableSections[0].title | translate)
            : ("o2o.create.table.product_information" | translate)
        }}
      </h2>
      <div
        class="px-2 pt-2 flex gap-2 justify-between items-center w-full"
        *ngIf="tableSections.length && tableSections[0].actions as actions"
      >
        <!-- Product Search Field (Left) -->
        <div
          class="w-1/2 flex-1 product-search-wrapper"
          *ngIf="!hideProductSearch"
        >
          <p-autocomplete
            [(ngModel)]="productSearchValue"
            [suggestions]="productSearchSuggestions"
            [minLength]="1"
            [showClear]="true"
            [dropdown]="false"
            [forceSelection]="false"
            [attr.required]="false"
            placeholder="Tìm kiếm sản phẩm"
            (completeMethod)="onProductSearchField($event)"
            (onSelect)="onProductSearchSelect($event)"
            optionLabel="skuName"
            class="w-full text-sm product-search-autocomplete"
            [ngModelOptions]="{ standalone: true }"
          >
            <ng-template let-product pTemplate="item">
              <div
                class="flex flex-col py-2 px-2 border-b border-gray-100 last:border-b-0 w-full box-border product-search-item"
              >
                <div
                  class="product-search-item-name font-medium text-sm text-gray-900 mb-1.5 leading-tight"
                >
                  {{ product.skuName || product.spuName }}
                </div>
                <div
                  class="text-xs text-gray-600 flex justify-between items-center gap-2"
                >
                  <div class="flex flex-wrap gap-x-3 gap-y-0.5">
                    <span *ngIf="product.spuCode" class="text-gray-500">
                      Mã SP:
                      <span class="text-gray-700">{{ product.spuCode }}</span>
                    </span>
                    <span *ngIf="product.skuCode" class="text-gray-500">
                      Mã SKU:
                      <span class="text-gray-700">{{ product.skuCode }}</span>
                    </span>
                  </div>
                  <div
                    class="text-sm font-semibold text-gray-700 whitespace-nowrap"
                  >
                    {{
                      formatCurrency(
                        product.displayPrice || product.salesPrice || 0
                      )
                    }}
                  </div>
                </div>
              </div>
            </ng-template>
          </p-autocomplete>
        </div>
        <!-- Action Buttons (Right) -->
        <div
          class="flex gap-2 justify-end"
          [ngClass]="{
            'w-full': hideProductSearch,
            'w-1/2': !hideProductSearch,
          }"
        >
          <app-button
            *ngFor="let act of actions"
            [testId]="'order-create-layout-table-action-' + act.action"
            [label]="act.label | translate"
            [icon]="act.icon"
            (emitOnClick)="onActionClick(act)"
            [outlined]="act.outlined || false"
            [type]="act.severity || 'secondary'"
            [disabled]="act.disabled || false"
          ></app-button>
        </div>
      </div>
      <div class="px-2 pt-4" *ngIf="tableSections && tableSections.length">
        <div class="product-table-container">
          <app-data-table
            data-testid="order-create-layout-product-table"
            [dataSource]="tableSections[0].data || []"
            [columns]="tableSections[0].columns || []"
            [rows]="tableSections[0].rows || 20"
            [first]="tableSections[0].first || 0"
            [totalRecords]="
              tableSections[0].totalRecords || tableSections[0].data.length || 0
            "
            [loading]="tableSections[0].loading || false"
            [hasCheckColumn]="tableSections[0].hasCheckbox || false"
            [hasSerialColumn]="tableSections[0].hasSerialColumn !== false"
            [autoExpandRowsWithChildren]="autoExpandPackageChildren"
            [selection]="tableSections[0].selection || []"
            [scrollHeight]="'280px'"
            [rowsPerPageOptions]="
              tableSections[0].rowsPerPageOptions || [20, 50, 100]
            "
            (pageChange)="tableSections[0].onPageChange?.($event)"
            (selectionChange)="tableSelections(tableSections[0].title!, $event)"
            (cellValueChange)="onTableCellValueChange($event)"
            (cellInputChange)="onTableCellInputChange($event)"
            class="text-sm"
          >
            <ng-template
              #customTemplate
              let-value
              let-rowData="rowData"
              let-column="column"
            >
              <ng-container [ngSwitch]="column.template || column.prop">
                <ng-container *ngSwitchCase="'currencyTemplate'">
                  <span class="text-xs text-right">{{
                    formatCurrency(value)
                  }}</span>
                </ng-container>
                <ng-container *ngSwitchCase="'giftFlag'">
                  <span class="text-xs justify-center items-center flex">
                    {{
                      value
                        ? ("common.options.yes" | translate)
                        : ("common.options.no" | translate)
                    }}
                  </span>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  {{ value }}
                </ng-container>
              </ng-container>
            </ng-template>
          </app-data-table>
        </div>
      </div>
    </section>

    <!-- Order Summary moved to right-rail below Promotion -->

    <!-- 4. Customer Information -->
    <section class="form-section">
      <div class="flex justify-between items-center mb-2">
        <h2 class="section-title text-sm">
          {{
            "o2o.create.form.sections.buyer_recipient_information" | translate
          }}
        </h2>
        <div class="flex gap-2">
          <app-button
            *ngFor="
              let btn of getSectionButtons(
                'o2o.create.form.sections.buyer_recipient_information'
              )
            "
            [testId]="'order-create-layout-buyer-recipient-action-' + btn.action"
            [label]="btn.label | translate"
            [icon]="btn.icon"
            (emitOnClick)="onSectiButtonClick(btn)"
            [outlined]="btn.outlined || false"
            [type]="btn.severity || 'secondary'"
            [disabled]="btn.disabled || false"
          ></app-button>
        </div>
      </div>
      <div class="grid gap-2 px-4 py-2 grid-cols-3">
        <ng-container
          *ngFor="
            let field of fieldsBySection(
              'o2o.create.form.sections.buyer_recipient_information'
            );
            trackBy: trackByControlName
          "
        >
          <div
            class="form-field"
            *ngIf="visibleInContext(field)"
            [class.col-span-2]="field.colspan === 2"
            [class.col-span-4]="field.colspan === 4"
          >
            <label [for]="field.controlName" class="form-label text-sm">
              {{ field.label | translate }}
              <span *ngIf="field.required" class="text-red-500">*</span>
            </label>
            <ng-container [ngSwitch]="field.type">
              <textarea
                *ngSwitchCase="'textarea'"
                [id]="field.controlName"
                class="w-full text-sm"
                [class.ng-invalid]="getFieldError(field.controlName)"
                [placeholder]="field.placeholder | translate"
                rows="3"
                [attr.required]="field.required ? '' : null"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="onFieldChange($event, field)"
                (blur)="onFieldBlur($any($event).target.value, field)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
                [readonly]="field.readonly || false"
              ></textarea>
              <p-select
                *ngSwitchCase="'dropdown'"
                [options]="getOptions(field.controlName)"
                optionLabel="label"
                optionValue="value"
                [placeholder]="field.placeholder | translate"
                [attr.required]="field.required ? '' : null"
                [emptyMessage]="
                  field.emptyMessage || ('common.no_results' | translate)
                "
                class="w-full text-sm"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="form.get(field.controlName)?.setValue($event)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
              >
              </p-select>
              <p-select
                *ngSwitchCase="'searchableDropdown'"
                [options]="getOptions(field.controlName)"
                optionLabel="label"
                optionValue="value"
                (onFilter)="field.onFilter?.($event.filter)"
                (onLazyLoad)="field.onLazyLoad?.($event)"
                [filter]="field.filter ?? true"
                [filterBy]="field.filterBy || 'label'"
                [loading]="field.loading"
                [lazy]="!!field.onLazyLoad"
                [virtualScroll]="field.virtualScroll ?? false"
                [virtualScrollItemSize]="field.virtualScrollItemSize"
                optionDisabled="disabled"
                [showClear]="field.showClear || false"
                [placeholder]="field.placeholder | translate"
                [attr.required]="field.required ? '' : null"
                [filterPlaceholder]="
                  field.filterPlaceholder
                    ? (field.filterPlaceholder | translate)
                    : ('common.search.form.actions.search' | translate)
                "
                class="w-full text-sm"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="
                  field.controlName === 'provinceId'
                    ? onProvinceChange($event, field)
                    : form.get(field.controlName)?.setValue($event)
                "
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
              >
                <ng-template let-option pTemplate="item">
                  <div
                    *ngIf="option?.loading; else optionLabel"
                    class="dropdown-loading-more-option"
                  >
                    <span
                      class="dropdown-loading-more-spinner"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <ng-template #optionLabel>
                    <span>{{ option?.label }}</span>
                  </ng-template>
                </ng-template>
                <ng-template
                  pTemplate="footer"
                  *ngIf="
                    field.onLoadMore &&
                    field.hasMore &&
                    !field.autoLoadMore
                  "
                >
                  <div class="dropdown-load-more-footer">
                    <p-button
                      [attr.data-testid]="
                        'order-create-layout-load-more-' + field.controlName
                      "
                      size="small"
                      severity="secondary"
                      text
                      [label]="
                        (field.loadMoreLabel || 'common.show_more') | translate
                      "
                      [loading]="field.loadingMore"
                      [disabled]="field.loadingMore"
                      (onClick)="field.onLoadMore()"
                    ></p-button>
                  </div>
                </ng-template>
              </p-select>
              <input
                *ngSwitchDefault
                pInputText
                class="w-full text-sm"
                [class.ng-invalid]="getFieldError(field.controlName)"
                [placeholder]="field.placeholder | translate"
                type="text"
                [attr.required]="field.required ? '' : null"
                [attr.value]="getPaymentValue(field.controlName) ?? null"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="onFieldChange($event, field)"
                (blur)="onFieldBlur($any($event).target.value, field)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
                [readonly]="field.readonly || false"
              />
            </ng-container>
            <small
              *ngIf="getFieldError(field.controlName)"
              class="text-red-500 text-xs mt-1 block"
            >
              {{ getFieldError(field.controlName) | translate: getFieldErrorParams(field.controlName) }}
            </small>
          </div>
        </ng-container>
      </div>
    </section>

    <!-- 5. Fulfillment Method (new section) -->
    <section
      class="form-section"
      *ngIf="
        fieldsBySection('o2o.create.form.sections.fulfillment_method').length
      "
    >
      <h2 class="section-title text-sm">
        {{ "o2o.create.form.sections.fulfillment_method" | translate }}
      </h2>
      <div class="grid gap-2 px-4 py-2 grid-cols-3">
        <ng-container
          *ngFor="
            let field of fieldsBySection(
              'o2o.create.form.sections.fulfillment_method'
            );
            trackBy: trackByControlName
          "
        >
          <div
            class="form-field"
            *ngIf="visibleInContext(field)"
            [class.col-span-2]="field.colspan === 2"
            [class.col-span-4]="field.colspan === 4"
          >
            <label [for]="field.controlName" class="form-label text-sm">
              {{ field.label | translate }}
              <span *ngIf="field.required" class="text-red-500">*</span>
            </label>
            <ng-container [ngSwitch]="field.type">
              <p-select
                *ngSwitchCase="'dropdown'"
                [options]="getOptions(field.controlName)"
                optionLabel="label"
                optionValue="value"
                [placeholder]="field.placeholder | translate"
                [attr.required]="field.required ? '' : null"
                [emptyMessage]="
                  field.emptyMessage || ('common.no_results' | translate)
                "
                [ngModel]="
                  field.controlName === 'takingDeliveryWay'
                    ? takingDeliveryWay
                    : getPaymentValue(field.controlName)
                "
                (ngModelChange)="
                  field.controlName === 'takingDeliveryWay'
                    ? onTakingDeliveryWayChange($event)
                    : form.get(field.controlName)?.setValue($event)
                "
                [ngModelOptions]="{ standalone: true }"
                class="w-full text-sm"
                [disabled]="
                  field.loading || field.disabled || field.readonly || false
                "
                [loading]="field.loading || false"
              >
              </p-select>
              <p-select
                *ngSwitchCase="'searchableDropdown'"
                [options]="getOptions(field.controlName)"
                optionLabel="label"
                optionValue="value"
                (onFilter)="field.onFilter?.($event.filter)"
                (onLazyLoad)="field.onLazyLoad?.($event)"
                [filter]="field.filter ?? true"
                [filterBy]="field.filterBy || 'label'"
                [loading]="field.loading"
                [lazy]="!!field.onLazyLoad"
                [virtualScroll]="field.virtualScroll ?? false"
                [virtualScrollItemSize]="field.virtualScrollItemSize"
                optionDisabled="disabled"
                [showClear]="field.showClear || false"
                [placeholder]="field.placeholder | translate"
                [attr.required]="field.required ? '' : null"
                [filterPlaceholder]="
                  field.filterPlaceholder
                    ? (field.filterPlaceholder | translate)
                    : ('common.search.form.actions.search' | translate)
                "
                class="w-full text-sm"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="form.get(field.controlName)?.setValue($event)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.loading || field.disabled || field.readonly || false"
              >
                <ng-template let-option pTemplate="item">
                  <div
                    *ngIf="option?.loading; else optionLabelFulfillment"
                    class="dropdown-loading-more-option"
                  >
                    <span
                      class="dropdown-loading-more-spinner"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <ng-template #optionLabelFulfillment>
                    <span>{{ option?.label }}</span>
                  </ng-template>
                </ng-template>
                <ng-template
                  pTemplate="footer"
                  *ngIf="
                    field.onLoadMore &&
                    field.hasMore &&
                    !field.autoLoadMore
                  "
                >
                  <div class="dropdown-load-more-footer">
                    <p-button
                      size="small"
                      severity="secondary"
                      text
                      [label]="
                        (field.loadMoreLabel || 'common.show_more') | translate
                      "
                      [loading]="field.loadingMore"
                      [disabled]="field.loadingMore"
                      (onClick)="field.onLoadMore()"
                    ></p-button>
                  </div>
                </ng-template>
              </p-select>
              <input
                *ngSwitchDefault
                pInputText
                class="w-full text-sm"
                [class.ng-invalid]="getFieldError(field.controlName)"
                [placeholder]="field.placeholder | translate"
                type="text"
                [attr.required]="field.required ? '' : null"
                [attr.value]="getPaymentValue(field.controlName) ?? null"
                [ngModel]="getPaymentValue(field.controlName)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
                [readonly]="field.readonly || false"
              />
            </ng-container>
            <small
              *ngIf="getFieldError(field.controlName)"
              class="text-red-500 text-xs mt-1 block"
            >
              {{ getFieldError(field.controlName) | translate: getFieldErrorParams(field.controlName) }}
            </small>
          </div>
        </ng-container>
      </div>
    </section>

    <!-- 6. Delivery Information (visible only when it has visible fields, e.g. Tracking Number once shipped) -->
    <section
      class="form-section"
      *ngIf="
        fieldsBySection('o2o.create.form.sections.delivery_information')
          .length
      "
    >
      <h2 class="section-title text-sm">
        {{ "o2o.create.form.sections.delivery_information" | translate }}
      </h2>
      <div class="grid gap-2 px-4 py-2 grid-cols-3">
        <ng-container
          *ngFor="
            let field of fieldsBySection(
              'o2o.create.form.sections.delivery_information'
            );
            trackBy: trackByControlName
          "
        >
          <div
            class="form-field"
            *ngIf="visibleInContext(field)"
            [class.col-span-2]="field.colspan === 2"
            [class.col-span-4]="field.colspan === 4"
          >
            <label [for]="field.controlName" class="form-label text-sm">
              {{ field.label | translate }}
              <span *ngIf="field.required" class="text-red-500">*</span>
            </label>
            <ng-container [ngSwitch]="field.type">
              <textarea
                *ngSwitchCase="'textarea'"
                [id]="field.controlName"
                class="w-full text-sm"
                [placeholder]="field.placeholder | translate"
                rows="3"
                [attr.required]="field.required ? '' : null"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="form.get(field.controlName)?.setValue($event)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
                [readonly]="field.readonly || false"
              ></textarea>
              <p-inputNumber
                *ngSwitchCase="'number'"
                [min]="getMinValue(field)"
                [max]="getMaxValue(field)"
                [placeholder]="field.placeholder | translate"
                [attr.required]="field.required ? '' : null"
                [suffix]="field.suffix || ''"
                [showButtons]="false"
                inputId="{{ field.controlName }}"
                class="w-full text-sm"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="form.get(field.controlName)?.setValue($event)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
              ></p-inputNumber>
              <p-inputNumber
                *ngSwitchCase="'currency'"
                [mode]="'currency'"
                [currency]="'VND'"
                [locale]="'vi-VN'"
                [placeholder]="field.placeholder | translate"
                [attr.required]="field.required ? '' : null"
                inputId="{{ field.controlName }}"
                class="w-full text-sm"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="form.get(field.controlName)?.setValue($event)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
              ></p-inputNumber>
              <p-select
                *ngSwitchCase="'dropdown'"
                [options]="getOptions(field.controlName)"
                optionLabel="label"
                optionValue="value"
                [placeholder]="field.placeholder | translate"
                [attr.required]="field.required ? '' : null"
                [emptyMessage]="
                  field.emptyMessage || ('common.no_results' | translate)
                "
                class="w-full text-sm"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="
                  field.controlName === 'provinceId'
                    ? onProvinceChange($event, field)
                    : field.controlName === 'shippingUnit' ||
                        field.controlName === 'shippingService'
                      ? onFieldChange($event, field)
                      : form.get(field.controlName)?.setValue($event)
                "
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
              >
              </p-select>
              <p-select
                *ngSwitchCase="'searchableDropdown'"
                [options]="getOptions(field.controlName)"
                optionLabel="label"
                optionValue="value"
                (onFilter)="field.onFilter?.($event.filter)"
                (onLazyLoad)="field.onLazyLoad?.($event)"
                [filter]="field.filter ?? true"
                [filterBy]="field.filterBy || 'label'"
                [loading]="field.loading"
                [lazy]="!!field.onLazyLoad"
                [virtualScroll]="field.virtualScroll ?? false"
                [virtualScrollItemSize]="field.virtualScrollItemSize"
                optionDisabled="disabled"
                [showClear]="field.showClear || false"
                [placeholder]="field.placeholder | translate"
                [attr.required]="field.required ? '' : null"
                [filterPlaceholder]="
                  field.filterPlaceholder
                    ? (field.filterPlaceholder | translate)
                    : ('common.search.form.actions.search' | translate)
                "
                class="w-full text-sm"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="
                  field.controlName === 'provinceId'
                    ? onProvinceChange($event, field)
                    : form.get(field.controlName)?.setValue($event)
                "
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
              >
                <ng-template let-option pTemplate="item">
                  <div
                    *ngIf="option?.loading; else optionLabel2"
                    class="dropdown-loading-more-option"
                  >
                    <span
                      class="dropdown-loading-more-spinner"
                      aria-hidden="true"
                    ></span>
                  </div>
                  <ng-template #optionLabel2>
                    <span>{{ option?.label }}</span>
                  </ng-template>
                </ng-template>
                <ng-template
                  pTemplate="footer"
                  *ngIf="
                    field.onLoadMore &&
                    field.hasMore &&
                    !field.autoLoadMore
                  "
                >
                  <div class="dropdown-load-more-footer">
                    <p-button
                      [attr.data-testid]="
                        'order-create-layout-load-more-' + field.controlName
                      "
                      size="small"
                      severity="secondary"
                      text
                      [label]="
                        (field.loadMoreLabel || 'common.show_more') | translate
                      "
                      [loading]="field.loadingMore"
                      [disabled]="field.loadingMore"
                      (onClick)="field.onLoadMore()"
                    ></p-button>
                  </div>
                </ng-template>
              </p-select>
              <input
                *ngSwitchDefault
                pInputText
                class="w-full text-sm"
                [placeholder]="field.placeholder | translate"
                type="text"
                [attr.required]="field.required ? '' : null"
                [attr.value]="getPaymentValue(field.controlName) ?? null"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="form.get(field.controlName)?.setValue($event)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
                [readonly]="field.readonly || false"
              />
            </ng-container>
          </div>
        </ng-container>
      </div>
    </section>
  </div>
  <div class="right-rail">
    <!-- 7. Payment Information (Hidden - O2O Summary section displays prices) -->
    <section class="form-section" *ngIf="false">
      <h2 class="section-title text-sm">
        {{ "o2o.create.form.sections.payment_information" | translate }}
      </h2>
      <div class="grid gap-2 px-4 py-2 grid-cols-1">
        <ng-container
          *ngFor="
            let field of fieldsBySection(
              'o2o.create.form.sections.payment_information'
            );
            trackBy: trackByControlName
          "
        >
          <div
            class="form-field"
            *ngIf="visibleInContext(field)"
            [class.col-span-2]="field.colspan === 2"
            [class.col-span-4]="field.colspan === 4"
          >
            <label [for]="field.controlName" class="form-label text-sm">
              {{ field.label | translate }}
              <span *ngIf="field.required" class="text-red-500">*</span>
            </label>
            <ng-container [ngSwitch]="field.type">
              <textarea
                *ngSwitchCase="'textarea'"
                [id]="field.controlName"
                class="w-full text-sm"
                [placeholder]="field.placeholder | translate"
                rows="3"
                [attr.required]="field.required ? '' : null"
              ></textarea>
              <p-select
                *ngSwitchCase="'dropdown'"
                [options]="getOptions(field.controlName)"
                optionLabel="label"
                optionValue="value"
                [placeholder]="field.placeholder | translate"
                [attr.required]="field.required ? '' : null"
                class="w-full text-sm"
              >
              </p-select>
              <input
                *ngSwitchDefault
                pInputText
                class="w-full text-sm"
                [placeholder]="field.placeholder | translate"
                type="text"
                [attr.required]="field.required ? '' : null"
                [attr.value]="getPaymentValue(field.controlName) ?? null"
              />
            </ng-container>
          </div>
        </ng-container>
      </div>
    </section>

    <!-- 8. Shipping fee information (POS / when fields provided) -->
    <section
      class="form-section"
      *ngIf="
        fieldsBySection('order.internal.shipping_fee_information').length
      "
    >
      <h2 class="section-title text-sm">
        {{ "order.internal.shipping_fee_information" | translate }}
      </h2>
      <div class="grid gap-2 px-4 py-2 grid-cols-3">
        <ng-container
          *ngFor="
            let field of fieldsBySection(
              'order.internal.shipping_fee_information'
            );
            trackBy: trackByControlName
          "
        >
          <div
            class="form-field"
            *ngIf="visibleInContext(field)"
            [class.col-span-2]="field.colspan === 2"
            [class.col-span-3]="field.colspan === 3 || field.colspan === 4"
          >
            <label [for]="field.controlName" class="form-label text-sm">
              {{ field.label | translate }}
              <span *ngIf="field.required" class="text-red-500">*</span>
            </label>
            <ng-container [ngSwitch]="field.type">
              <div *ngSwitchCase="'radio'" class="flex gap-4 flex-wrap mt-1">
                <div
                  class="flex items-center"
                  *ngFor="let option of field.options || []"
                >
                  <input
                    type="radio"
                    class="mr-1"
                    [name]="field.controlName"
                    [id]="field.controlName + '_' + option.value"
                    [checked]="getPaymentValue(field.controlName) === option.value"
                    [disabled]="field.disabled || field.readonly || false"
                    (change)="onRadioModelChange(field.controlName, option.value)"
                  />
                  <label
                    class="ml-1 text-sm"
                    [for]="field.controlName + '_' + option.value"
                  >
                    {{ option.label | translate }}
                  </label>
                </div>
              </div>
              <input
                *ngSwitchDefault
                pInputText
                class="w-full text-sm"
                [placeholder]="field.placeholder | translate"
                type="text"
                [ngModel]="getPaymentValue(field.controlName)"
                (ngModelChange)="form.get(field.controlName)?.setValue($event)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="field.disabled || field.readonly || false"
              />
            </ng-container>
          </div>
        </ng-container>
      </div>
    </section>

    <!-- 9. Promotion / Discount Information -->
    <section
      class="form-section"
      *ngIf="
        fieldsBySection('o2o.create.form.sections.discount_information').length
      "
    >
      <h2 class="section-title text-sm">
        {{ "o2o.create.form.sections.discount_information" | translate }}
      </h2>
      <div class="grid gap-2 px-4 py-2 grid-cols-3">
        <ng-container
          *ngFor="
            let field of fieldsBySection(
              'o2o.create.form.sections.discount_information'
            );
            trackBy: trackByControlName
          "
        >
          <div
            class="form-field"
            *ngIf="visibleInContext(field)"
            [class.col-span-2]="field.colspan === 2"
            [class.col-span-4]="field.colspan === 4"
            [class.col-span-3]="
              field.type === 'couponAutocomplete' ||
              field.controlName === 'selectedPromotionOffersDisplay' ||
              field.type === 'radio'
            "
          >
            <div class="flex items-center justify-between gap-2">
              <label [for]="field.controlName" class="form-label text-sm">
                {{ field.label | translate }}
                <span *ngIf="field.required" class="text-red-500">*</span>
              </label>
              <app-button
                *ngIf="field.controlName === 'selectedPromotionOffersDisplay'"
                testId="order-create-layout-find-eligible-promotions-btn"
                [label]="'o2o.create.actions.find_eligible_promotions' | translate"
                icon="search"
                (emitOnClick)="onFindEligiblePromotions()"
                [outlined]="true"
                type="secondary"
              ></app-button>
            </div>
            <ng-container [ngSwitch]="field.type">
              <div *ngSwitchCase="'radio'" class="flex gap-4 flex-wrap mt-1">
                <div
                  class="flex items-center"
                  *ngFor="let option of field.options || []"
                >
                  <input
                    type="radio"
                    class="mr-1"
                    [name]="field.controlName"
                    [id]="field.controlName + '_' + option.value"
                    [checked]="getPaymentValue(field.controlName) === option.value"
                    [disabled]="field.disabled || field.readonly || false"
                    (change)="onRadioModelChange(field.controlName, option.value)"
                  />
                  <label
                    class="ml-1 text-sm"
                    [for]="field.controlName + '_' + option.value"
                  >
                    {{ option.label | translate }}
                  </label>
                </div>
              </div>
              <ng-container *ngSwitchCase="'dropdown'">
                <div
                  *ngIf="field.multiple"
                  class="promotion-multiselect-wrapper"
                >
                  <p-multiselect
                    [options]="getOptions(field.controlName)"
                    optionLabel="label"
                    optionValue="value"
                    [placeholder]="field.placeholder | translate"
                    [emptyMessage]="
                      field.emptyMessage || ('common.no_results' | translate)
                    "
                    [showClear]="true"
                    display="chip"
                    class="w-full text-sm promotion-multiselect-field"
                    [ngModel]="getPaymentValue(field.controlName) || []"
                    (ngModelChange)="
                      form.get(field.controlName)?.setValue($event)
                    "
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="field.disabled || field.readonly || false"
                  ></p-multiselect>
                </div>
                <p-select
                  *ngIf="!field.multiple"
                  [options]="getOptions(field.controlName)"
                  optionLabel="label"
                  optionValue="value"
                  [placeholder]="field.placeholder | translate"
                  [emptyMessage]="
                    field.emptyMessage || ('common.no_results' | translate)
                  "
                  class="w-full text-sm"
                  [ngModel]="getPaymentValue(field.controlName)"
                  (ngModelChange)="form.get(field.controlName)?.setValue($event)"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="field.disabled || field.readonly || false"
                ></p-select>
              </ng-container>
              <div
                *ngSwitchCase="'couponAutocomplete'"
                class="coupon-autocomplete-wrapper"
              >
                <p-autocomplete
                  [suggestions]="couponSuggestions[field.controlName] || []"
                  [minLength]="1"
                  [showClear]="false"
                  [dropdown]="false"
                  [forceSelection]="false"
                  [attr.required]="false"
                  [multiple]="true"
                  [optionLabel]="'couponCode'"
                  [placeholder]="field.placeholder | translate"
                  [class]="'w-full text-sm coupon-autocomplete-field'"
                  [disabled]="isDisableCoupon"
                  (completeMethod)="
                    couponSearch.emit({
                      query: $event.query,
                      field: field.controlName,
                    })
                  "
                  (onSelect)="
                    couponSelect.emit({
                      selected: $event,
                      field: field.controlName,
                    })
                  "
                  (onUnselect)="
                    couponUnselect.emit({
                      removed: $event,
                      field: field.controlName,
                    })
                  "
                >
                  <ng-template let-coupon pTemplate="item">
                    {{ coupon?.couponCode }}
                  </ng-template>
                </p-autocomplete>
              </div>
              <div *ngSwitchCase="'text'" class="w-full">
                <div
                  *ngIf="field.controlName === 'selectedPromotionOffersDisplay'; else defaultTextField"
                  class="coupon-autocomplete-wrapper"
                >
                  <p-autocomplete
                    [suggestions]="[]"
                    [minLength]="1"
                    [showClear]="false"
                    [dropdown]="false"
                    [forceSelection]="false"
                    [attr.required]="false"
                    [multiple]="true"
                    [optionLabel]="'offerName'"
                    [placeholder]="field.placeholder | translate"
                    [class]="'w-full text-sm coupon-autocomplete-field'"
                    [ngModel]="getPaymentValue(field.controlName) || []"
                    (ngModelChange)="form.get(field.controlName)?.setValue($event)"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="field.disabled || false"
                  >
                  </p-autocomplete>
                </div>
                <ng-template #defaultTextField>
                  <input
                    pInputText
                    class="w-full text-sm"
                    [placeholder]="field.placeholder | translate"
                    type="text"
                    [attr.required]="field.required ? '' : null"
                    [attr.value]="getPaymentValue(field.controlName) ?? null"
                    [ngModel]="getPaymentValue(field.controlName)"
                    (ngModelChange)="form.get(field.controlName)?.setValue($event)"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="field.disabled || field.readonly || false"
                    [readonly]="field.readonly || false"
                  />
                </ng-template>
              </div>
              <input
                *ngSwitchDefault
                pInputText
                class="w-full text-sm"
                [placeholder]="field.placeholder | translate"
                type="text"
                [attr.required]="field.required ? '' : null"
                [attr.value]="getPaymentValue(field.controlName) ?? null"
              />
            </ng-container>
          </div>
        </ng-container>
      </div>
    </section>

    <!-- 3. Order Summary (right column) -->
    <section class="form-section" *ngIf="summarySection && summarySection.show">
      <h2 class="section-title text-sm">
        {{ summarySection.title | translate }}
      </h2>
      <div class="grid gap-2 px-4 py-2 grid-cols-1">
        <div
          class="flex justify-between items-center text-sm"
          *ngFor="let item of summarySection.items"
        >
          <div class="text-gray-600">{{ item.label | translate }}</div>
          <div class="font-bold text-red-500">
            <ng-container [ngSwitch]="item.formatter">
              <span *ngSwitchCase="'currency'">{{
                formatCurrency(item.value)
              }}</span>
              <span *ngSwitchCase="'number'">{{
                formatNumber(item.value)
              }}</span>
              <span *ngSwitchDefault>{{ item.value }}</span>
            </ng-container>
          </div>
        </div>
      </div>
    </section>

    <section
      class="form-section"
      *ngFor="let section of trailingSections"
      [hidden]="!section.show"
    >
      <h2 class="section-title text-sm">
        {{ section.title | translate }}
      </h2>
      <div class="grid gap-2 px-4 py-2 grid-cols-1">
        <div
          class="flex justify-between items-center text-sm"
          *ngFor="let item of section.items"
        >
          <div class="text-gray-600">{{ item.label | translate }}</div>
          <div class="font-bold text-gray-800">
            <ng-container [ngSwitch]="item.formatter">
              <span *ngSwitchCase="'currency'">{{
                formatCurrency(item.value)
              }}</span>
              <span *ngSwitchCase="'number'">{{
                formatNumber(item.value)
              }}</span>
              <span *ngSwitchDefault>{{ item.value }}</span>
            </ng-container>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
